import axios from 'axios';

import type {
  IUserFindDeletedRequest,
  IUserFindDeletedQuery,
  IUserFindDeletedResponse,
} from '@/app-package';

const findDeleted = async (params?: IUserFindDeletedQuery) => {
  const config: IUserFindDeletedRequest = {
    url: '/user/deleted',
    method: 'get',
    params,
  };

  const { data } = await axios.request<IUserFindDeletedResponse>(config);

  return data;
};

export default findDeleted;
